import { render, staticRenderFns } from "./formularioDespesa.vue?vue&type=template&id=2cca6af8"
import script from "./formularioDespesa.vue?vue&type=script&lang=js"
export * from "./formularioDespesa.vue?vue&type=script&lang=js"
import style0 from "./formularioDespesa.vue?vue&type=style&index=0&id=2cca6af8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports